module.exports = __webpack_public_path__ + "static/media/profile.7598590a.jpg";